<template>
  <div id="NewsList">
    <div class="header">
      <span>NEWS</span>
      <h2>最新消息</h2>
    </div>
    <div class="list">
      <router-link
        :to="`/news/${item.news_id}`"
        v-for="item in news_data"
        :key="item.news_id"
        class="card"
      >
        <span class="tag">{{ item.category }}</span>
        <p class="date">{{ item.create_time.slice(0, 10) }}</p>
        <h4>{{ item.title }}</h4>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsList",
  data() {
    return {
      news_data: [],
    };
  },
  methods: {
    async GetNewsoData() {
      let result = await this.SendGetData(
        process.env.VUE_APP_BASE_API + "news/get_news_list.php"
      );
      if (result != "error") {
        let data = JSON.parse(result.data);
        this.news_data = data;
        this.news_data.sort((a, b) => {
          return a.position - b.position;
        });
        this.$nextTick(() => {
          window.prerenderReady = true;
        });
      }
    },
  },
  created() {
    this.GetNewsoData();
  },
  metaInfo() {
    return {
      title: "最新消息｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content:
            "Rerace 鋭仕技研，起源於2018年。長年專注於開發高品質高性能的避震器內管套件產品，並針對不同需求的玩家進行相對應並且可調的產品開發，希望讓每個喜愛玩車的人都能擁有一支適合自己的避震系統產品研發設計由總經理親自操刀，致力於優化現有避震器構造及材料應用。製造皆由專業技師使用高精密度機器製造，製造過程不放過任何一點小細節。一切都是為了讓喜歡我們的消費者能在購買使用產品後能有物超所值的感受",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content:
            "Rerace 鋭仕技研，起源於2018年。長年專注於開發高品質高性能的避震器內管套件產品，並針對不同需求的玩家進行相對應並且可調的產品開發，希望讓每個喜愛玩車的人都能擁有一支適合自己的避震系統產品研發設計由總經理親自操刀，致力於優化現有避震器構造及材料應用。製造皆由專業技師使用高精密度機器製造，製造過程不放過任何一點小細節。一切都是為了讓喜歡我們的消費者能在購買使用產品後能有物超所值的感受",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content:
            "Rerace 鋭仕技研，起源於2018年。長年專注於開發高品質高性能的避震器內管套件產品，並針對不同需求的玩家進行相對應並且可調的產品開發，希望讓每個喜愛玩車的人都能擁有一支適合自己的避震系統產品研發設計由總經理親自操刀，致力於優化現有避震器構造及材料應用。製造皆由專業技師使用高精密度機器製造，製造過程不放過任何一點小細節。一切都是為了讓喜歡我們的消費者能在購買使用產品後能有物超所值的感受",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "最新消息｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "最新消息｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "最新消息｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
